exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".web-components-___DealStatus__list___2A1tZ{list-style:none;padding-left:1em;margin-top:.5em}.web-components-___DealStatus__list___2A1tZ>li{padding:.3em;padding-left:1.3em;color:#95989a;background-repeat:no-repeat;background-position:0;background-size:1em;font-size:1.1em}.web-components-___DealStatus__bullet___35phy{background-image:url(\"/images/bullet-grey.svg\")}.web-components-___DealStatus__arrow___3RNbZ{background-image:url(\"/images/bullet-arrow.svg\")}.web-components-___DealStatus__tick___qxMQ5{background-image:url(\"/images/bullet-tick.svg\")}", ""]);

// exports
exports.locals = {
	"list": "web-components-___DealStatus__list___2A1tZ",
	"bullet": "web-components-___DealStatus__bullet___35phy",
	"arrow": "web-components-___DealStatus__arrow___3RNbZ",
	"tick": "web-components-___DealStatus__tick___qxMQ5"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?importLoader=1&modules&localIdentName=[path]___[name]__[local]___[hash:base64:5]&?minimize=true!./web/components/DealStatus.css
// module id = 1328
// module chunks = 0